import { createContext as e, useCallback as t, useContext as n, useMemo as r, useRef as i, useState as a } from "react";
import { jsx as o } from "react/jsx-runtime";
//#region src/table/primitive/selection-context.tsx
var s = e({
	isSelected: () => !1,
	onToggle: () => {},
	isEveryRowSelected: !1,
	isSomeRowSelected: !1,
	onSelectEveryRow: () => {},
	onDeselectEveryRow: () => {},
	registerRow: () => () => {},
	rowCount: 0,
	selectionMode: "none"
}), c = ({ children: e, onSelectionChange: n, selectedKeys: c, selectionMode: l = "none" }) => {
	let [u, d] = a([]), f = i(/* @__PURE__ */ new Map()), p = t((e) => {
		let t = (f.current.get(e) ?? 0) + 1;
		return f.current.set(e, t), t === 1 && d((t) => t.includes(e) ? t : [...t, e]), () => {
			let t = (f.current.get(e) ?? 1) - 1;
			if (t > 0) {
				f.current.set(e, t);
				return;
			}
			f.current.delete(e), d((t) => t.filter((t) => t !== e));
		};
	}, []), m = r(() => {
		let e = new Set(c ?? []), t = u.filter((t) => e.has(t)).length;
		return {
			selectionMode: l,
			registerRow: p,
			rowCount: u.length,
			isSelected: (t) => e.has(t),
			isEveryRowSelected: u.length > 0 && t === u.length,
			isSomeRowSelected: t > 0,
			onSelectEveryRow: () => {
				let t = new Set(e);
				u.forEach((e) => t.add(e)), n?.(t);
			},
			onDeselectEveryRow: () => {
				let t = new Set(e);
				u.forEach((e) => t.delete(e)), n?.(t);
			},
			onToggle: (t) => {
				if (l === "none") return;
				if (l === "single") {
					n?.(e.has(t) ? /* @__PURE__ */ new Set() : /* @__PURE__ */ new Set([t]));
					return;
				}
				let r = new Set(e);
				r.has(t) ? r.delete(t) : r.add(t), n?.(r);
			}
		};
	}, [
		n,
		p,
		u,
		c,
		l
	]);
	return /* @__PURE__ */ o(s.Provider, {
		value: m,
		children: e
	});
}, l = () => n(s);
//#endregion
export { c as TableSelectionProvider, l as useTableSelection };
